
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.sic-tabs{
  overflow:hidden;
}

.sic-tabs--list{
  display:flex;
  flex-direction:column;
  list-style:none;
  padding:0;
  background-color:var(--color-neutral-white);
}

@media (min-width: 1024px){

.sic-tabs--list{
    border-bottom:solid var(--color-neutral-lighter) 2px
}
  }

.sic-tabs--list li a{
    display:block;
    padding:1rem;
    text-decoration:none;
    color:var(--color-primary-default);
    border-bottom:solid var(--color-neutral-lighter) 2px;
    position:relative;
  }

.sic-tabs--list li a::after{
      display:block;
      content:'';
      width:100%;
      height:2px;
      background-color:transparent;
      margin-top:calc(var(--spacing-1) * -1);
      position:absolute;
      bottom:-2px;
      left:0;
    }

.sic-tabs--list li a:focus{
      outline:solid var(--color-primary-default) 2px;
      border-radius:var(--border-radius-button-default);
      outline-offset:-1px;
    }

.sic-tabs--list li a:hover::after{
        background-color:var(--color-primary-default);
      }

.sic-tabs--list li a:hover{
      border-color:var(--color-primary-default);
}

@media (min-width: 1024px){

.sic-tabs--list li a{
      margin-bottom:-2px;
      border-color:transparent
  }
      .sic-tabs--list li a::after{
        position:relative;
      }
    }

.sic-tabs--list li a[aria-selected='true']{
    background-color:var(--color-tertiary-lightest);
    border-color:var(--color-tertiary-default);
  }

@media (min-width: 1024px){

.sic-tabs--list{
    flex-direction:row
}
  }
`;